import { gsap } from 'gsap';

import AudioPlayer from '../../common/audio/main';
import SystemUtils from '../../common/utils/system';


export default class Review{

    constructor(){
        this.scene = GAME_REF.scene;

        this.$self = null;
        this.items = null;
        this.keys = [];
        this.soundAssets = {};

        this.timer = null;
        this._pause = this._pause.bind(this);
        this._resume = this._resume.bind(this);


        this._init();
    }

    render(){
        this.$self.classList.add('-active');
        this._playAudio();

        window.addEventListener(PLAYBACK.EVENT.PAGE_PAUSE, this._pause);
        window.addEventListener(PLAYBACK.EVENT.PAGE_RESUME, this._resume);
    }

    hide(){
        this.$self.classList.remove('-active');
    }

    _init(){
        this.$self = document.querySelector('.js-review');
        this.items = document.querySelectorAll('.js-review__item');
        this._createNa();
    }


    _createNa(){
        const ext = window.navigator.userAgent.match(/Android/) ? ".ogg" : ".mp3"; 

        this.soundAssets.title = {src:[`./assets/audio/review/title${ext}`]};

        this.keys.push('title');
        this.items.forEach($item=>{
            const key = $item.getAttribute('data-key');
            this.soundAssets[key] = {src:[`./assets/audio/review/${key + ext}`]};
            this.keys.push(key);
        });
    }

    _playAudio(){
        const sound = new AudioPlayer(this.soundAssets);
        sound.load()
            .then(() => {
                sound.playSequence(this.keys, ()=>{
                    
                    this.timer = gsap.delayedCall(2, ()=>{
                        window.removeEventListener(PLAYBACK.EVENT.PAGE_PAUSE, this._pause);
                        window.removeEventListener(PLAYBACK.EVENT.PAGE_RESUME, this._resume);
                        this.timer = null;

                        this.hide();
                        this.scene.goodjob.render();
                    });
                });
        
                sound.setOnSequenceOneStart(key => {
                    if(key === 'title') return;
                    document.querySelector(`.js-review__item.-${key}`).classList.add('-current');
                });
                
                sound.setOnSequenceOneEnd(key =>{
                    if(key === 'title') return;
                    document.querySelector(`.js-review__item.-${key}`).classList.remove('-current');
                });
            })
            .catch((err) => {});
    }

    _pause(){
        if(this.timer) this.timer.pause();
    }

    _resume(){
        if(this.timer) this.timer.resume();
    }
}